const SERVICE_WORKER_URL = "/service-worker.js";

export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  // Quando um novo SW toma controle, recarrega para pegar bundle novo
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(SERVICE_WORKER_URL, { scope: "/" });

      // Força checagem imediata de atualização do SW a cada 30s (iOS PWA)
      setInterval(() => {
        registration.update().catch(() => {});
      }, 30000);

      // Quando encontrar novo SW esperando, aciona skipWaiting via mensagem
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            // Novo SW instalado e há um SW antigo ativo — aciona troca imediata
            newWorker.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
    } catch (error) {
      console.error("Erro ao registrar service worker:", error);
    }
  });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}
